import InputTypesEnum from "../../../Enums/InputTypesEnum";
import ValidityHelper from "../../../Helpers/ValidityHelper";
import IobItem from "../../../Domain/IobItem";
import IobService from "../../../Services/IobService";

class EditIobWindowDescription {
  static titleForCreate = 'Add New IOB';
  static titleForEdit = 'Edit IOB';
  static itemType = IobItem;
  static serviceFunction = (edited) => IobService.UpsertIob(edited);

  static pagesInGeneralEditWizzard = [
    {
      label: 'IOB Details',
      fields: [
        {
          fieldName: 'ToOfficeId',
          label: 'Bill To Office *',
          className: 'col-12',
          type: InputTypesEnum.OfficeSelect,
          validityChecker: ValidityHelper.forRequiredSelectField,
          hide: (item) => item.Status === 'Finalized' || item.Status === 'Paid',
        },
        {
          fieldName: 'ClientId',
          label: 'Client',
          className: 'col-12',
          type: InputTypesEnum.ClientSelect,
          validityChecker: ValidityHelper.emptyValidityChecker,
          hide: (item) => item.Status === 'Finalized' || item.Status === 'Paid',
        },
        {
          fieldName: 'ProjectId',
          label: 'Project',
          className: 'col-12',
          type: InputTypesEnum.ProjectSelect,
          idFilter: 'ClientId',
          validityChecker: ValidityHelper.emptyValidityChecker,
          hide: (item) => item.Status === 'Finalized' || item.Status === 'Paid',
        },
        {
          fieldName: 'InternalReferenceNumber',
          label: 'Internal Reference Number',
          className: 'col-12',
          type: InputTypesEnum.Text,
          validityChecker: ValidityHelper.emptyValidityChecker,
        },
        {
          fieldName: 'Comments',
          label: 'Comments',
          className: 'col-12',
          type: InputTypesEnum.TextBox,
          validityChecker: ValidityHelper.emptyValidityChecker,
          numberOfRows: 2,
        },
      ],
    },
  ];
}

export default EditIobWindowDescription;